import React, { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  MoveLeft,
  LogIn,
  LogOut,
  Coffee,
  Paperclip,
  UserCheck,
} from "lucide-react";
import Dialog from "@mui/material/Dialog";
import DatePicker from "react-datepicker";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaArrowLeft } from "react-icons/fa"; // Importing Arrow Left from Font Awesome
import { useSelector } from "react-redux";
import { workAttachmentProof } from "../../actioncreators/actioncreators";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import ArthaContinueButton from "../../fields/ArthaContinueButton";
import AddTimeEntry from "./AddTimeEntry";
import Slide from "@mui/material/Slide";
// import { FetchTimesheetHoursClickApi } from "../../actioncreators/actioncreators";

const TimeEntries = () => {
  // State for work proof list popup
  const [isWorkProofListDialogOpen, setIsWorkProofListDialogOpen] = useState(false);
  // State for individual attachment view popup
  const [isAttachmentDialogOpen, setIsAttachmentDialogOpen] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [workProofAttachments, setWorkProofAttachments] = useState([]);
  const [isLoadingWorkProofs, setIsLoadingWorkProofs] = useState(false);
  const [workProofError, setWorkProofError] = useState(null);
  const timeentries1 = useSelector((state) => state.fetchTimeEntries);
  const userId = useSelector((state) => state.FetchImage?.userId) || timeentries1?.timeentries?.[0]?.user_id;
  const imageData = useSelector((state) => state.FetchImage?.imageData);
  const fullName = useSelector((state) => state.FetchImage?.fullName);
  const FetchWorkedHours = useSelector((state) => state.FetchWorkedHours);
  const [isAddTimeEntryOpen, setIsAddTimeEntryOpen] = useState(false); // Manage dialog visibility
  console.log("timeentries1", timeentries1);
  const timeentries = useSelector(
    (state) => state.fetchTimeEntries.timeentries
  );

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  // Ensure the image data is correctly formatted for base64
  const imageDataFinal = imageData
    ? imageData.replace(/-/g, "+").replace(/_/g, "/") +
      "=".repeat((4 - (imageData.length % 4)) % 4) // Correct any padding issues
    : "";

  const navigate = useNavigate();
  const imageSrc = imageData
    ? `data:image/jpeg;base64,${imageData}`
    : "/placeholder.png";

  const [activeTab, setActiveTab] = useState("Timesheets");
  const [timesheetData, setTimesheetData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [timeEntries, setTimeEntries] = useState([]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: "Asia/Kolkata",
    });
  };

  function formatToAMPM(dateTime) {
    const date = new Date(dateTime);

    // Extract hours, minutes, and seconds
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");

    // Determine AM or PM and adjust the hour for 12-hour format
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 or 12+ to 12-hour format

    // Format the time as hh:mm:ss AM/PM
    return `${hours}:${minutes} ${ampm}`;
  }

  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Name", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Total"],
      ...timesheetData.map((employee) => [
        employee.fullName,
        // ...employee.daily.map(day => day.isRestDay ? 'Rest' : formatTime(day.workedHours)),
        // formatTime(employee.total)
      ]),
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheets");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "Timesheets.xlsx");
  };

  //   const [selectedDate, setSelectedDate] = useState(new Date()); // User's selected date

  // Get the current week's Sunday date
  const getWeekDays = (startDate) => {
    const days = [];
    let currentDate = new Date(startDate);

    for (let i = 0; i < 7; i++) {
      // Format the day as 'Mon, 21'
      const day = currentDate.toLocaleDateString("default", {
        weekday: "short",
        day: "numeric",
      });
      days.push({
        formattedDay: day,
        fullDate: currentDate.toISOString().split("T")[0], // Store full date in 'YYYY-MM-DD' format
      });
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }

    return days;
  };

  const weekDays = getWeekDays(timeentries1?.weekStart); // Generate week days dynamically

  // Filter work proof attachments from timeentries
  const workProofs = React.useMemo(() => {
    if (!timeentries || timeentries.length === 0) return [];
    return timeentries.filter(entry => entry.activity_type === "WORKPROOF");
  }, [timeentries]);

  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  // Function to fetch work proof attachments
  const fetchWorkProofAttachments = async () => {
    if (!selectedDate || !userId) {
      setWorkProofError("Date or User ID is missing");
      return;
    }

    setIsLoadingWorkProofs(true);
    setWorkProofError(null);
    
    try {
      const payload = {
        date: selectedDate,
        userId: userId
      };
      
      const response = await workAttachmentProof(payload);
      
      if (response && response.timeEntries) {
        setWorkProofAttachments(response.timeEntries);
      } else {
        setWorkProofAttachments([]);
      }
    } catch (error) {
      console.error("Error fetching work proof attachments:", error);
      setWorkProofError("Failed to fetch work proof attachments");
      setWorkProofAttachments([]);
    } finally {
      setIsLoadingWorkProofs(false);
    }
  };

  // Handle Work Proofs button click
  const handleWorkProofsClick = () => {
    setSelectedAttachment(null);
    setIsWorkProofListDialogOpen(true);
    fetchWorkProofAttachments();
  };

  // Handle individual attachment view
  const handleViewAttachment = (attachment) => {
    setSelectedAttachment(attachment);
    setIsAttachmentDialogOpen(true);
  };
  const storedWorkedHours = FetchWorkedHours; // The fetched worked hours array
  const selectedIndex = timeentries1.selectedIndex; // The selected index from the state or prop
  const dayHours = storedWorkedHours?.[selectedIndex] || []; // Get the hours for the selected index, defaulting to an empty array if undefined

  // Retrieve the selected date from localStorage
  const selectedDate = timeentries1?.selectedDate || null;

  const handleAddMemberSuccess = () => {
    setIsAddTimeEntryOpen(false); // Close the dialog after success
  };
  return (
    <div className="container-fluid p-0 m-0">
      {/* Sidebar */}

      <div className="row" style={{ backgroundColor: "#EFF0F4" }}>
        <div className="col-12 col-md-12 flex items-center py-2 border-bottom text-black-50">
          <button
            onClick={() => navigate("/home/timesheets")}
            className="text-dark"
          >
            <MoveLeft />
          </button>
          <div className="flex items-center justify-between w-full">
            <span className=" font-semibold ">Time Entries</span>
            <button
              className="ml-4 px-2 py-1 md:px-4 md:py-2 bg-blue-1000 text-white rounded hover:bg-blue-600 text-xs md:text-sm"
              onClick={handleWorkProofsClick}
            >
              Work Proofs
            </button>
          </div>
          {/* <div className="ms-auto ">
            <ArthaContinueButton
              style={{
                fontSize: "12px",
                width: "120px",
                height: "30px",
              }}
              onClick={() => setIsAddTimeEntryOpen(true)}
            >
              Add Time Entry
            </ArthaContinueButton>
          </div> */}
        </div>

        {/* Week Navigation */}
        <div className="col-12 col-md-3 items-center border-end text-black-50 text-center">
          {imageDataFinal ? (
            <img
              src={`data:image/jpeg;base64,${imageDataFinal}`}
              alt="Employee"
              className="rounded-circle mt-2 p-3"
              style={{ width: "100%", height: "60%" }}
            />
          ) : (
            <div className="rounded-circle mt-2 p-3 d-flex align-items-center justify-content-center" 
              style={{ 
                width: "100%", 
                aspectRatio: "1",
                backgroundColor: "#f3f4f6",
                color: "#6b7280",
                fontSize: "14px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px"
              }}>
              No Image Available
            </div>
          )}
          <span className="font-semibold text-gray-700 text-center pb-2">
            {fullName}
          </span>
          <hr />
          <div className="row text-sm">
            <div className="col-12 col-md-12 d-flex mt-4">
            <span className="col-8 text-left">Total Worked Hours</span>
            <span className="col-4 text-sm  text-gray-700 text-center">
              {timeentries1?.totalWorkedHours}
            </span>
            </div>
            <div className="col-12 col-md-12 d-flex mt-2">
            <span className="col-8 text-left">Total Breaks</span>
            <span className="col-4 text-sm  text-gray-700 text-center">
              {timeentries1?.totalBreakHours}
            </span>
            </div>
            <div className="col-12 col-md-12 d-flex mt-2">
            <span className="col-8 text-left">Total Overtime Hours</span>
            <span className="col-4 text-sm  text-gray-700 text-center">
              {timeentries1?.totalOverTime}
            </span>
            </div>
         
          </div>
        </div>

        <div className="col-12 col-md-9 p-0 m-0">
          <div className="col-12 col-md-12 flex items-center border-bottom text-black-50">
            {/* Previous Week Button */}
            <button className="text-dark">
              <ChevronLeft />
            </button>

            {/* DisCoffee dynamically generated week days */}
            <div className="flex">
              {/* <div className="grid grid-cols-8 gap-1 md:gap-4 px-4"> */}
              {weekDays.map((day, index) => {
                const isSelected = day.fullDate === selectedDate;
                return (
                  <div
                    key={day.formattedDay}
                    className={`text-center px-1 py-1 ${
                      isSelected
                        ? "border-b-4 border-t-0 border-l-0 border-r-0"
                        : "text-gray-1000"
                    }`}
                    style={isSelected ? { borderColor: "#fd5f07" } : {}}
                  >
                    <div className="text-sm font-medium">
                      {day.formattedDay}
                    </div>
                    <div
                      className={`mt-1 rounded-full px-3 py-2 ${
                        isSelected ? "" : "text-gray-400"
                      }`}
                      style={isSelected ? { color: "#fd5f07" } : {}}
                    >
                      {dayHours[index] || "0h 0m"}{" "}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Next Week Button */}
            <button className="text-dark">
              <ChevronRight />
            </button>
          </div>
          <div className="col-12 col-md-12 p-2 bg-white border-bottom text-black-50" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {isLoading ? (
              <div className="text-center py-8">Loading...</div>
            ) : error ? (
              <div className="text-center py-8 text-red-1000">{error}</div>
            ) : (
              <div className="flex flex-col w-full">
                {timeentries?.length > 0 ? (
                  timeentries.map((entry) => {
                    // Helper function to format remarks for display
                    const formatRemark = (remark) => {
                      if (!remark) return null;
                      // Convert snake_case to Title Case
                      return remark.split('_').map(word => 
                        word.charAt(0) + word.slice(1).toLowerCase()
                      ).join(' ');
                    };

                    // Helper function to get remark badge color
                    const getRemarkBadgeColor = (remark) => {
                      if (!remark) return {};
                      
                      const remarkLower = remark.toLowerCase();
                      if (remarkLower.includes('violation') || remarkLower.includes('voilation')) {
                        return { backgroundColor: '#fee2e2', color: '#991b1b', borderColor: '#fca5a5' };
                      } else if (remarkLower.includes('schedule') || remarkLower.includes('time')) {
                        return { backgroundColor: '#fef3c7', color: '#92400e', borderColor: '#fcd34d' };
                      } else if (remarkLower.includes('late')) {
                        return { backgroundColor: '#ffedd5', color: '#9a3412', borderColor: '#fdba74' };
                      } else if (remarkLower.includes('early')) {
                        return { backgroundColor: '#dbeafe', color: '#1e40af', borderColor: '#93c5fd' };
                      }
                      return { backgroundColor: '#f3f4f6', color: '#374151', borderColor: '#d1d5db' };
                    };

                    // Debug log
                    if (entry.remarks) {
                      console.log("Entry with remarks:", entry.remarks);
                    }

                    return (
                    <div
                      key={entry.activity_id}
                      className="p-1 flex items-center hover:bg-gray-50 w-full"
                    >
                      <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mr-4">
                        {/* Icon based on ActivityType */}
                        {entry.activity_type === "CHECKIN" ? (
                          <LogIn size={24} className="text-green-1000" />
                        ) : entry.activity_type === "CHECKOUT" ? (
                          <LogOut size={24} className="text-red-1000" />
                        ) : entry.activity_type === "ATTENDANCE" ? (
                          <UserCheck size={24} className="text-purple-1000" />
                        ) : entry.activity_type === "START_BREAK" ? (
                          <Coffee size={24} className="text-yellow-1000" />
                        ) : entry.activity_type === "END_BREAK" ? (
                          <Coffee size={24} className="text-yellow-1000" />
                        ) : entry.activity_type === "WORKPROOF" ? (
                          <Paperclip size={24} className="text-blue-1000" />
                        ) : (
                          <LogOut size={24} className="text-red-1000" />
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium" style={{ marginBottom: '2px' }}>
                          {formatDate(entry.date_and_time)}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                          {/* Display Remarks Badge inline before activity */}
                          {entry.remarks && (
                            <span 
                              style={{
                                ...getRemarkBadgeColor(entry.remarks),
                                fontSize: '9px',
                                fontWeight: '600',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                display: 'inline-block',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                lineHeight: '1.2'
                              }}
                            >
                              {formatRemark(entry.remarks)}
                            </span>
                          )}
                          <span className="text-xs text-gray-1000">
                            {entry.activity_type === "CHECKIN"
                              ? "Clock in at "
                              : entry.activity_type === "CHECKOUT"
                              ? "Clock out at "
                              : entry.activity_type === "ATTENDANCE"
                              ? "Attendance at "
                              : entry.activity_type === "START_BREAK"
                              ? "Break started at "
                              : entry.activity_type === "END_BREAK"
                              ? "Break ended at "
                              : entry.activity_type === "WORKPROOF"
                              ? "Work Proof Attachment at "
                              : "Activity at "} {" "}
                            {formatToAMPM(entry.date_and_time)}
                          </span>
                        </div>
                      </div>
                      {/* Show 'View Attachment' button for ATTACHMENT type, always at right */}
                      {entry.activity_type === "WORKPROOF" && (
                        <div className="flex items-center justify-end min-w-[120px]">
                          <button
                            className="ml-2 md:ml-4 px-2 py-1 md:px-3 md:py-1 bg-blue-1000 text-white rounded hover:bg-blue-600 text-xs"
                            onClick={() => {
                              setSelectedAttachment(entry);
                              setIsAttachmentDialogOpen(true);
                            }}
                          >
                            View Attachment
                          </button>
                        </div>
                      )}
                    </div>
                  );
                  })
                ) : (
                  <div className="text-center py-8">
                    No time entries found
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Rest Banner - Show only if it's a rest day */}
        {false && (
          <div className="bg-gray-50 p-4 rounded-lg mb-6 flex items-center">
            <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-3">
              <span className="text-gray-1000">R</span>
            </div>
            <span className="text-gray-600">Rest day</span>
          </div>
        )}
      </div>
      <Dialog
        TransitionComponent={Transition}
        open={isAddTimeEntryOpen}
        onClose={() => setIsAddTimeEntryOpen(false)}
        maxWidth="sm"
        fullWidth
        aria-hidden={!isAddTimeEntryOpen}
        inert={!isAddTimeEntryOpen ? "true" : undefined}
      >
        <AddTimeEntry
          isOpen={isAddTimeEntryOpen}
          onClose={() => setIsAddTimeEntryOpen(false)}
          onSuccess={handleAddMemberSuccess}
          className="bg-white border p-0 m-0"
        />
      </Dialog>

      {/* Work Proof List Dialog */}
      <Dialog
        open={isWorkProofListDialogOpen}
        onClose={() => setIsWorkProofListDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
            maxHeight: '80vh'
          }
        }}
      >
        {/* Header */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Paperclip size={20} style={{ color: '#ffffff' }} />
            <h2 style={{ 
              margin: 0, 
              fontSize: 18, 
              fontWeight: 700, 
              color: '#ffffff',
              letterSpacing: 0.3
            }}>
              Work Proof Attachments
            </h2>
          </div>
          <IconButton 
            aria-label="close" 
            onClick={() => setIsWorkProofListDialogOpen(false)}
            style={{ 
              color: '#ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              padding: 6
            }}
          >
            <CloseIcon style={{ fontSize: 18 }} />
          </IconButton>
        </div>

        {/* Scrollable Content */}
        <div style={{ 
          padding: '16px 20px', 
          maxHeight: 'calc(80vh - 70px)', 
          overflowY: 'auto',
          backgroundColor: '#f8f9fa'
        }}>
          {isLoadingWorkProofs ? (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              background: '#ffffff',
              borderRadius: 12,
              color: '#718096',
              fontSize: 14
            }}>
              <div style={{ fontWeight: 1000 }}>Loading work proof attachments...</div>
            </div>
          ) : workProofError ? (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              background: '#ffffff',
              borderRadius: 12,
              color: '#e53e3e',
              fontSize: 14
            }}>
              <div style={{ fontWeight: 1000 }}>{workProofError}</div>
            </div>
          ) : workProofAttachments.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              background: '#ffffff',
              borderRadius: 12,
              color: '#718096',
              fontSize: 14
            }}>
              <Paperclip size={36} style={{ color: '#cbd5e0', marginBottom: 12 }} />
              <div style={{ fontWeight: 1000 }}>No work proof attachments found for this date</div>
            </div>
          ) : (
            workProofAttachments.map((proof, index) => {
              return (
              <div 
                key={proof.activity_id} 
                style={{ 
                  marginBottom: 12,
                  background: '#ffffff',
                  borderRadius: 12,
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                  border: '1px solid #e2e8f0',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => handleViewAttachment(proof)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.12)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.06)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16
                }}>
                  {/* Thumbnail */}
                  <div style={{
                    width: 80,
                    height: 80,
                    borderRadius: 8,
                    overflow: 'hidden',
                    background: '#f7fafc',
                    border: '2px solid #e2e8f0',
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {proof.image_data ? (
                      <img
                        src={`data:image/jpeg;base64,${proof.image_data}`}
                        alt="Work Proof"
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <Paperclip size={32} style={{ color: '#cbd5e0' }} />
                    )}
                  </div>

                  {/* Details */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ 
                      fontSize: 14, 
                      fontWeight: 600,
                      color: '#2d3748',
                      marginBottom: 4
                    }}>
                      Work Proof #{index + 1}
                    </div>
                    <div style={{ 
                      fontSize: 12, 
                      color: '#718096',
                      marginBottom: 6
                    }}>
                      {formatDate(proof.date_and_time)} • {formatToAMPM(proof.date_and_time)}
                    </div>
                    {proof.coordinates && (
                      <div style={{ 
                        fontSize: 11, 
                        color: '#48bb78',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4
                      }}>
                        📍 Location Available
                      </div>
                    )}
                  </div>

                  {/* Arrow Icon */}
                  <div style={{ color: '#a0aec0' }}>
                    <ChevronRight size={20} />
                  </div>
                </div>
              </div>
            );
            })
          )}
        </div>
      </Dialog>

      {/* Individual Work Proof Attachment Dialog */}
      <Dialog
        open={isAttachmentDialogOpen}
        onClose={() => {
          setIsAttachmentDialogOpen(false);
          setSelectedAttachment(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
            height: '85vh',
            maxHeight: '700px'
          }
        }}
      >
        {/* Header */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button
              onClick={() => {
                setIsAttachmentDialogOpen(false);
                setSelectedAttachment(null);
              }}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#ffffff',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: 0
              }}
            >
              <MoveLeft size={20} />
            </button>
            <Paperclip size={20} style={{ color: '#ffffff' }} />
            <h2 style={{ 
              margin: 0, 
              fontSize: 18, 
              fontWeight: 700, 
              color: '#ffffff',
              letterSpacing: 0.3
            }}>
              Work Proof Attachment
            </h2>
          </div>
          <IconButton 
            aria-label="close" 
            onClick={() => {
              setIsAttachmentDialogOpen(false);
              setSelectedAttachment(null);
            }}
            style={{ 
              color: '#ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              padding: 6
            }}
          >
            <CloseIcon style={{ fontSize: 18 }} />
          </IconButton>
        </div>

        {/* Content */}
        <div style={{ 
          padding: '16px 20px', 
          height: 'calc(100% - 70px)', 
          overflowY: 'auto',
          backgroundColor: '#f8f9fa'
        }}>
          {!selectedAttachment ? (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              background: '#ffffff',
              borderRadius: 12,
              color: '#718096',
              fontSize: 14
            }}>
              <Paperclip size={36} style={{ color: '#cbd5e0', marginBottom: 12 }} />
              <div style={{ fontWeight: 1000 }}>No work proof attachment selected</div>
            </div>
          ) : (
            <div style={{ 
              marginBottom: 16,
              background: '#ffffff',
              borderRadius: 12,
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              border: '1px solid #e2e8f0'
            }}>
              {/* Date/Time Header */}
              <div style={{
                padding: '12px 16px',
                background: 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)',
                borderBottom: '1px solid #e2e8f0'
              }}>
                <div style={{ 
                  fontSize: 14, 
                  color: '#2d3748',
                  fontWeight: 600
                }}>
                  {formatDate(selectedAttachment.date_and_time)} • {formatToAMPM(selectedAttachment.date_and_time)}
                </div>
              </div>

              {/* Content - 70% Image, 30% Details */}
              <div style={{ 
                padding: 16,
                display: 'flex',
                gap: 16
              }}>
                {/* Image - 70% Space */}
                <div style={{ 
                  flex: '0 0 70%',
                  minHeight: 350,
                  maxHeight: 400
                }}>
                  <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f7fafc',
                    borderRadius: 12,
                    overflow: 'hidden',
                    border: '2px solid #e2e8f0',
                    position: 'relative',
                    cursor: 'pointer',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                  }}
                  onClick={() => selectedAttachment.image_data && window.open(`data:image/jpeg;base64,${selectedAttachment.image_data}`, '_blank')}
                  >
                    {selectedAttachment.image_data ? (
                      <>
                        <img
                          src={`data:image/jpeg;base64,${selectedAttachment.image_data}`}
                          alt="Work Proof"
                          style={{ 
                            width: '100%', 
                            height: '100%', 
                            objectFit: 'contain'
                          }}
                        />
                        <div style={{
                          position: 'absolute',
                          bottom: 12,
                          right: 12,
                          background: 'rgba(0, 0, 0, 0.75)',
                          color: '#ffffff',
                          padding: '8px 14px',
                          borderRadius: 8,
                          fontSize: 11,
                          fontWeight: 600,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6
                        }}>
                          🔍 Click to expand
                        </div>
                      </>
                    ) : (
                      <div style={{ 
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f3f4f6',
                        borderRadius: '8px',
                        color: '#6b7280',
                        fontSize: '14px',
                        fontWeight: 1000,
                        textAlign: 'center'
                      }}>
                        No Image Available
                      </div>
                    )}
                  </div>
                </div>

                {/* Compact Details - 30% Space */}
                <div style={{ 
                  flex: '0 0 30%',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 10,
                  overflowY: 'auto'
                }}>
                  {/* Location */}
                  {selectedAttachment.coordinates && (
                    <div style={{
                      padding: 10,
                      background: '#f0fff4',
                      borderRadius: 8,
                      borderLeft: '3px solid #48bb78'
                    }}>
                      <div style={{ 
                        fontSize: 10, 
                        color: '#2f855a', 
                        fontWeight: 700,
                        marginBottom: 4,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5
                      }}>
                        📍 Location
                      </div>
                      <div style={{ fontSize: 10, color: '#2d3748', marginBottom: 3, wordBreak: 'break-all' }}>
                        {selectedAttachment.coordinates.latitude.toFixed(4)}, {selectedAttachment.coordinates.longitude.toFixed(4)}
                        {selectedAttachment.location_name && <><br /> • {selectedAttachment.location_name}</>}
                      </div>
                      <a
                        href={`https://www.google.com/maps?q=${selectedAttachment.coordinates.latitude},${selectedAttachment.coordinates.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#4299e1',
                          fontSize: 9,
                          fontWeight: 600,
                          textDecoration: 'none'
                        }}
                      >
                        View Map →
                      </a>
                    </div>
                  )}

                  {/* Device Info */}
                  {selectedAttachment.device_details && (
                    <div style={{
                      padding: 10,
                      background: '#fffaf0',
                      borderRadius: 8,
                      borderLeft: '3px solid #ed8936'
                    }}>
                      <div style={{ 
                        fontSize: 10, 
                        color: '#c05621', 
                        fontWeight: 700,
                        marginBottom: 4,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5
                      }}>
                        📱 Device
                      </div>
                      <div style={{ fontSize: 10, color: '#2d3748', lineHeight: 1.4 }}>
                        {selectedAttachment.device_details.manufacturer} {selectedAttachment.device_details.model}
                      </div>
                      <div style={{ fontSize: 9, color: '#718096', marginTop: 2 }}>
                        {selectedAttachment.device_details.platform} {selectedAttachment.device_details.version}
                      </div>
                    </div>
                  )}

                  {/* Remarks */}
                  {selectedAttachment.remarks && (
                    <div style={{
                      padding: 10,
                      background: '#faf5ff',
                      borderRadius: 8,
                      borderLeft: '3px solid #9f7aea'
                    }}>
                      <div style={{ 
                        fontSize: 10, 
                        color: '#6b46c1', 
                        fontWeight: 700,
                        marginBottom: 4,
                        textTransform: 'uppercase',
                        letterSpacing: 0.5
                      }}>
                        💬 Remarks
                      </div>
                      <div style={{ 
                        fontSize: 10, 
                        color: '#2d3748',
                        lineHeight: 1.4
                      }}>
                        {selectedAttachment.remarks}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
  // };
};

export default TimeEntries;
